// -------------------------------------
// Back to Top
// -------------------------------------
(function($) {

  // Dreamlab Back to Top button
  var $btn = $("#back-to-top");

  if ($btn.length) {

    var scrollThreshold = $btn.data("threshold"), // Scroll threshold in pixels
      backToTop = function() {

        var scrollTop = $(window).scrollTop();

        if (scrollTop > scrollThreshold) {
          // Show button
          $btn.addClass("is-shown");
          $btn.removeClass("is-hidden");
          // console.log("Showing back to top button");
        } else {
          // Hide button
          $btn.removeClass("is-shown");
          $btn.addClass("is-hidden");
          // console.log("Hiding back to top button");
        }

      };

    // Get distance from top
    backToTop();

    // When scrolling get distance from top
    $(window).on("scroll", function() {
      backToTop();
    });

    $btn.on("click", function(e) {
      e.preventDefault();
      $("html,body").animate({
        scrollTop: 0
      }, $btn.data("duration")); // Back To Top Animation duration in milliseconds
      // Remove focus after button is clicked
      // $btn.blur().trigger("mouseleave");
    });

  }

})(jQuery);
